import { combineReducers } from 'redux'

import loginReducer from './login.reducer'
import roleReducer from './roleorg.reducer'
import monthlyReducer from './monthly.reducer'
import modeReducer from './mode.reducer'
import menuRightReducer from './menu-right.reducer'
import profilePercentReducer from './percentprofile.reducer'
import allMenuReducer from './allMenu.reducer'
import profileReducer from './profile.reducer'

const rootReducer = combineReducers({
  loginReducer,
  roleReducer,
  monthlyReducer,
  modeReducer,
  menuRightReducer,
  profilePercentReducer,
  allMenuReducer,
  profileReducer
})

export default rootReducer
